import type { ZoneCrossing } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

/** What the trip's GPS fixes add up to (gitaumoses4/chukua#93). `null` on the trip means "not available", which is not 0 km. */
export interface TripGpsDistance {
  distanceM: number;
  coveragePct: number;
  computedAt: string;
  isLowCoverage: boolean;
}

export interface JobTrip {
  id: string;
  number: string;
  jobId: string;
  legType: string;
  status: string;
  originZoneCode: string | null;
  destinationZoneCode: string | null;
  truckId: string | null;
  driverId: string | null;
  gpsDistance: TripGpsDistance | null;
  createdAt: string;
}

/** The trip's arrivals and departures at watched zones, oldest first. */
export function listTripCrossings(tripId: string): Promise<ZoneCrossing[]> {
  return api<ZoneCrossing[]>(`/trips/${tripId}/crossings`);
}

export function listJobTrips(jobId: string): Promise<{ trips: JobTrip[] }> {
  return api<{ trips: JobTrip[] }>(`/jobs/${jobId}/trips`);
}
